import './polyfills';
import './devextreme-form-editors';
import ReactDOM from 'react-dom/client';
import './index.css';
import { EventType } from '@azure/msal-browser';
import config from "devextreme/core/config";
import { MainApp } from './app';
import { msalInstance } from "./msal-instance";
import { licenseKey } from "./devextreme-license";

config({ licenseKey });

msalInstance.initialize().then(() => {
  // Default to using the first account if no account is active on page load
  if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
    // Account selection logic is app dependent. Adjust as needed for different use cases.
    msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
  }

  // Optional - This will update account state if a user signs in from another tab or window
  msalInstance.enableAccountStorageEvents();

  msalInstance.addEventCallback((event) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
      const account = event.payload.account;
      msalInstance.setActiveAccount(account);
    }
  });
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <MainApp pca={ msalInstance } />
);
